import { Component } from "@angular/core";

@Component({
    selector: "app-background",
    templateUrl: "./background.component.html",
    styleUrl: "./background.component.scss",
    standalone: false,
})
export class BackgroundComponent {}
